import { Tooltip } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { GetError } from "src/constant";
import { getMyData } from "src/thunks/auth";
import { isDropdownOpenFlag } from "src/thunks/dashboard";
import React from "react";


export const ProjectManagerProjectDropdown = ({ ProjectData, handleChange, projectGoodsInDropdownValue }) => {
    const projectDropdownData = ProjectData?.length > 0
        ? [
            { name: "ALL PROJECTS", id: 0 },
            ...ProjectData,
        ]
        : [];
    const allDepotsOption = projectDropdownData.length > 0 && projectDropdownData?.shift();
    projectDropdownData.length > 0 && projectDropdownData.sort((a, b) => a.name.localeCompare(b.name));
    projectDropdownData.length > 0 && projectDropdownData.unshift(allDepotsOption);
    const dropdownRef = useRef(null);


    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        getAllMyData()
    }, [])

    const getAllMyData = async () => {
        try {
            let res = await dispatch(getMyData()).unwrap();
        } catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");
        } finally {
        }
    };


    useEffect(() => {
        dispatch(isDropdownOpenFlag(open))
    }, [open])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const onElementClicked = (item) => {
        handleChange(item);
        setOpen((prevOpen) => !prevOpen);
    };
    const onButton = () => {
        setOpen(!open)
    };

    return (
        <>
            <div ref={dropdownRef}>
                <div style={{ flex: 1, color: "white" }}>
                    <div className="wrapper-projectManager-dropdown">
                        <div
                            className="button d-flex flex-row justify-content-between"
                            onClick={() => onButton()}
                        >
                            <Tooltip title={projectGoodsInDropdownValue.name == "ALL PROJECTS" ? "" : <span className="project-dropdown-tooltip-style1 project-dropdown-tooltip-style">{`${projectGoodsInDropdownValue.name || "ALL PROJECTS"}`}</span>} arrow>
                                <span className="projectname-wrap">
                                    {projectGoodsInDropdownValue.name || "ALL PROJECTS"}
                                </span>
                            </Tooltip>

                            {open ? (
                                <span>
                                    <i className="bi bi-chevron-up chevron-up-arrow"></i>
                                </span>
                            ) : (
                                <span>
                                    <i className="bi bi-chevron-down chevron-down-arrow"></i>
                                </span>
                            )}

                        </div>
                        {(projectDropdownData?.length > 0 && open) && (
                            <>
                                <div className={`content`}>

                                    {projectDropdownData.map((item, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <div className={projectGoodsInDropdownValue?.name === item.name ? `selected-dropdownfield` : ""}
                                                    onClick={() => onElementClicked(item)}
                                                >
                                                    {item.name}
                                                </div>
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}